import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { downloadDurableArticlesFile } from '../../redux/actions/accountingExpenses'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import {
  getAssetBookingManagementSearchForm,
  getReserveDocumentBooking,
  savehAssetBookingManagementDetail,
  searchAssetBookingManagementSearchForm,
} from '../../redux/actions/assetBookingManagement'
import AssetBookingManagementDetailForm from './AssetBookingManagementDetailForm'
import AssetBookingManagementDetailTable from './AssetBookingManagementDetailTable'
import { sessionGetItemObj } from '../../utils/sessionHelpers'

export default function AssetBookingManagementDetailWidgets(props) {
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [searchFormSchema, setSearchFormSchema] = useState()
  const [dataTableSchema, setDataTableSchema] = useState()
  const [isError, setIsError] = useState(false)

  const bookingInfo = sessionGetItemObj('bookingInfo')

  useEffect(() => {
    if (!props.schema?.isApprover && !props.schema.disabled) {
      callAssetBookingManagementSearchForm()
    } else {
      setDataTableSchema(props?.schema?.form?.assets || {})
    }
  }, [props.schema])

  const callAssetBookingManagementSearchForm = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const id = bookingInfo.id ? bookingInfo.id : ''
      var response = await getAssetBookingManagementSearchForm(id)
      if (response.model) {
        setSearchFormSchema(response?.model?.form?.searchForm)
        setDataTableSchema(response?.model?.form?.result)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSearch = async (request) => {
    console.log('onSearch', request)

    setIsLoading(true)
    startLoading()

    try {
      const id = bookingInfo.id ? bookingInfo.id : ''
      var response = await searchAssetBookingManagementSearchForm(request, id)
      console.log('my response ', response)
      if (response.model) {
        setDataTableSchema(response?.model)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 2500,
        })
      }
    } catch (e) {
      console.log('error => ', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleViewFiles = async (fileName, filePath) => {
    console.log('handleViewFiles ', filePath)

    setIsLoading(true)
    startLoading()
    try {
      var file = await downloadDurableArticlesFile(filePath)

      // downloadFile(file, fileName)
      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSaveApproved = async (request) => {
    console.log('handleSaveApproved ', request)

    setIsLoading(true)
    startLoading()

    try {
      let response = await savehAssetBookingManagementDetail(request)
      console.log('save ', response)
      if (response) {
        notification.open('success', {
          title: 'บันทึกสำเร็จ',
        })
        callAssetBookingManagementSearchForm()
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || 'ไม่สำเร็จ')
      } else {
        setIsError('ไม่สำเร็จ')
      }
    }

    doneLoading()
    setIsLoading(false)
    return true
  }

  const handleGetReserveDoc = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const id = bookingInfo.id ? bookingInfo.id : ''

      var file = await getReserveDocumentBooking(id)

      previewFile(file, `แบบฟอร์มขอใช้งานครุภัณฑ์โครงการ_${id}`)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel shaded bordered>
        {!formSchema?.isApprover && searchFormSchema && (
          <AssetBookingManagementDetailForm
            schema={searchFormSchema}
            onSearch={onSearch}
            loading={isLoading}
          />
        )}

        <AssetBookingManagementDetailTable
          schema={dataTableSchema}
          loading={isLoading}
          onViewFiles={handleViewFiles}
          formSchema={formSchema}
          onSave={handleSaveApproved}
          onPreview={handleGetReserveDoc}
        />
      </Panel>
    </>
  )
}
